// NPM
// Модалки от фансибокса
window.fbx = require('@fancyapps/ui/dist/fancybox.esm');

// Маска для инпутов
require('inputmask/dist/inputmask');

// Красивый селект
require('jquery-nice-select/js/jquery.nice-select');

// Отправка формы
require('vgformsender/dist/js/vgformsender');

// Local
// Bootstrap
export { default as Alert } from './boot/js/alert'
export { default as Button } from './boot/js/button'
export { default as Carousel } from './boot/js/carousel'
export { default as Collapse } from './boot/js/collapse'
export { default as Dropdown } from './boot/js/dropdown'
export { default as Modal } from './boot/js/modal'
export { default as Offcanvas } from './boot/js/offcanvas'
export { default as Popover } from './boot/js/popover'
export { default as ScrollSpy } from './boot/js/scrollspy'
export { default as Tab } from './boot/js/tab'
export { default as Toast } from './boot/js/toast'
export { default as Tooltip } from './boot/js/tooltip'

// Vegas
export { default as YaCounter } from './vegas/js/ym';
export { default as VegasUI } from './vegas/js/ui';
export { default as VegasBG } from './vegas/js/bg'; // TODO jQuery
export { default as VegasMask } from './vegas/js/mask'; // TODO jQuery
export { default as VegasModal } from './vegas/js/modal'; // TODO jQuery
export { default as VegasCarousel } from './vegas/js/carousel'; // TODO jQuery